import React, { useState, useEffect } from 'react';
import './DocumentsPage.scss';
import Sidebar from '../../components/Sidebar/Sidebar';
import SidebarSecond from '../../components/Sidebar/SidebarSecond';
import { documentTypesList } from './consts';
import { IDocumentType } from './types';
import strings from '../../resources/strings';
import { LanguagesBar } from '../../components/LanguagesBar';
import { AppState } from '../../store/rootReducer';
import { connect, useDispatch } from 'react-redux';
import { getLanguagesList } from '../../store/languages/selectors';
import { requestGetList } from '../../store/languages/actions';
import { DocumentsProps } from './types';
import TextEditor from '../../components/TextEditor/TextEditor';
import { Document } from '../../store/documents/types';
import { getDocumentsList } from '../../store/documents/selectors';
import { Button } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import { requestGetDocumentsList, requestSaveDocument } from '../../store/documents/actions';
import SnackbarMessage from '../../components/SnackbarMessage/SnackbarMessage';
import { validateLanguages } from '../../utils/Validator';

const DocumentsPage: React.FC<DocumentsProps> = (props) => {
    const dispatch = useDispatch();
    const [error, setError] = useState(false);
    const [success, setSuccess] = useState(false);
    const [languageValue, setLanguageValue] = React.useState('pl');
    const [documentType, setDocumentType] = useState<IDocumentType | undefined>(documentTypesList[0]);
    const [document, setDocument] = useState<Document | undefined>(
        props.documents.find((item) => item.type === documentType?.code),
    );

    useEffect(() => {
        dispatch(requestGetList());
        dispatch(requestGetDocumentsList());
    }, []);

    useEffect(() => {
        if (!document) setDocument(props.documents.find((item) => item.type === documentType?.code));
    }, [props.documents]);

    useEffect(() => {
        setDocument(props.documents.find((item) => item.type === documentType?.code));
    }, [documentType]);

    const handleSubmit = () => {
        if (!document) return;
        if (!validateLanguages([document], props.languages.length)) {
            setError(true);
            return;
        }
        dispatch(requestSaveDocument(document));
        setSuccess(true);
    };

    return (
        <div className="content">
            <Sidebar></Sidebar>
            <SidebarSecond
                data={documentTypesList}
                actualItemId={documentType?.id}
                title={strings.documents.title}
                isAddNew={false}
                hideStatus={true}
                setActualItemId={(id: string) => {
                    setDocumentType(documentTypesList.find((el) => el.id === id));
                }}
                actualLanguage={'en'}
            ></SidebarSecond>
            <div className="documents-editor">
                <LanguagesBar
                    languages={props.languages}
                    selectedLanguage={languageValue}
                    handleChange={setLanguageValue}
                ></LanguagesBar>
                <TextEditor
                    value={document?.text?.[languageValue]}
                    getText={(content: string) => {
                        if (document)
                            setDocument({
                                ...document,
                                text: { ...document.text, [languageValue]: content },
                            });
                    }}
                    setEventId={document?.type}
                    languageValue={languageValue}
                />
                <Button
                    startIcon={<SendIcon />}
                    className="publish-button"
                    variant="contained"
                    href="#contained-buttons"
                    onClick={handleSubmit}
                >
                    {strings.newsAndEvents.buttons.publish}
                </Button>
                <SnackbarMessage
                    serverity="error"
                    message={error ? strings.languagesValidation.errorMessage : ''}
                    clearMessage={() => {
                        setError(false);
                    }}
                ></SnackbarMessage>
                <SnackbarMessage
                    serverity="success"
                    message={success ? strings.tasks.successMessage : ''}
                    clearMessage={() => {
                        setSuccess(false);
                    }}
                ></SnackbarMessage>
            </div>
        </div>
    );
};

function mapStateToProps(state: AppState) {
    return {
        languages: getLanguagesList(state),
        documents: getDocumentsList(state),
    };
}

export default connect(mapStateToProps)(DocumentsPage);
